/* eslint-disable react/prop-types */
import React from 'react';

const Chevron = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <title>Chevron Arrow Down</title>
      <path
        fill="#25292D"
        fillRule="nonzero"
        transform="translate(3 5)"
        id="b"
        d="M1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 1 0-.708-.708L5 4.293 1.354.646z"
      />
    </svg>
  );
};

export default Chevron;
